// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-desc {
  position: absolute;
  right: 92px;
  
}
.bootstrap-switch {
  box-shadow: none !important;
}

::ng-deep app-add-edit-roles .accordion-toggle {
  height: 20px !important;
}

.select {
  margin: 3px 13px;
  color: rgba(0,0,0,.54);
  text-align:end
}

/*.item-text {
  border: 1px solid gray;
  padding: 7px 15px 7px 15px;
  margin: 5px;
  border: 1px solid #e1e1e1;
  border-radius: 18px;
}*/

.item-button {
  position: absolute;
  top: 9px;
  right: 19px;
  margin:0
}

.cut-word{
    width:80%
}

::ng-deep .mat-expansion-panel {
  box-shadow: 2px 2px 1px -1px rgba(0, 143, 199, 0.2) !important;
  border: 1px solid #ebedf2;
}

.card-header {
  border-bottom: 1px solid #ffffff;
}

.panel-body.card-block.card-body {
  padding-bottom: 0 !important;
}

.text-end {
  text-align: end
}
.container {
  text-align: center;

  .inner-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;


    .img {

      max-width: 300px;
      width: 300px;
    }

    .title {
      font-size: 2rem;
      font-weight: bold;
      color: #000;
      margin-bottom: 1rem;
    }

    .description {
      font-size: 1rem;
      color: #000;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/app/views/users-permissions/permissions/add-edit-roles/add-edit-roles.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;;AAEb;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB;AACF;;AAEA;;;;;;EAME;;AAEF;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX;AACF;;AAEA;IACI;AACJ;;AAEA;EACE,8DAA8D;EAC9D,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;AACF;AACA;EACE,kBAAkB;;EAElB;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;;IAGnB;;MAEE,gBAAgB;MAChB,YAAY;IACd;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,WAAW;IACb;EACF;AACF","sourcesContent":[".panel-desc {\r\n  position: absolute;\r\n  right: 92px;\r\n  \r\n}\r\n.bootstrap-switch {\r\n  box-shadow: none !important;\r\n}\r\n\r\n::ng-deep app-add-edit-roles .accordion-toggle {\r\n  height: 20px !important;\r\n}\r\n\r\n.select {\r\n  margin: 3px 13px;\r\n  color: rgba(0,0,0,.54);\r\n  text-align:end\r\n}\r\n\r\n/*.item-text {\r\n  border: 1px solid gray;\r\n  padding: 7px 15px 7px 15px;\r\n  margin: 5px;\r\n  border: 1px solid #e1e1e1;\r\n  border-radius: 18px;\r\n}*/\r\n\r\n.item-button {\r\n  position: absolute;\r\n  top: 9px;\r\n  right: 19px;\r\n  margin:0\r\n}\r\n\r\n.cut-word{\r\n    width:80%\r\n}\r\n\r\n::ng-deep .mat-expansion-panel {\r\n  box-shadow: 2px 2px 1px -1px rgba(0, 143, 199, 0.2) !important;\r\n  border: 1px solid #ebedf2;\r\n}\r\n\r\n.card-header {\r\n  border-bottom: 1px solid #ffffff;\r\n}\r\n\r\n.panel-body.card-block.card-body {\r\n  padding-bottom: 0 !important;\r\n}\r\n\r\n.text-end {\r\n  text-align: end\r\n}\r\n.container {\r\n  text-align: center;\r\n\r\n  .inner-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n\r\n    .img {\r\n\r\n      max-width: 300px;\r\n      width: 300px;\r\n    }\r\n\r\n    .title {\r\n      font-size: 2rem;\r\n      font-weight: bold;\r\n      color: #000;\r\n      margin-bottom: 1rem;\r\n    }\r\n\r\n    .description {\r\n      font-size: 1rem;\r\n      color: #000;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
